import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import '../src/assets/styles/app.scss'

import PrimeVue from 'primevue/config'
import 'primevue/resources/themes/saga-blue/theme.css'
import 'primeicons/primeicons.css'
import 'primevue/resources/primevue.min.css'

import CKEditor from '@ckeditor/ckeditor5-vue'

const app = createApp(App)

app
  .use(store)
  .use(router)
  .use(PrimeVue, {
    pt: {
      global: {
        css: `
          .p-datepicker-multiple-month {
            width: 850px;
          }

          .p-datepicker-group-container {
            gap: 20px;
          }

          .p-datepicker-calendar {
            font-size: 14px;
          }
      `
      }
    }
  })
  .use(CKEditor)
  .mount('#app')
